module.exports = __webpack_public_path__ + "img/fullwidth.07d9fe77.svg";